export const WORKERS_FOR_SELECT_PATH = "/v2/workers-for-select" as const;

export const workersForSelect = {
  all: [WORKERS_FOR_SELECT_PATH] as const,
  workers: (searchText: string) =>
    [...workersForSelect.all, { searchText }] as const,
} as const;
